module.exports = __webpack_public_path__ + "media/images/payments/westernunion-dark-aeb5948cb50d85ba5de62379a267b7a8.svg";